<template>
  <div>
    <BankAccountForm
      class="mb"
      :bank-accounts="user.bankAccounts"
      @validate-field="validateField"
    />
    <br />
    <FinancialDataForm
      :investment-profile="user.investmentProfile"
      @validate-field="validateField"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { BankAccountForm } from './components/BankAccountForm';
import { FinancialDataForm } from './components/FinancialDataForm';
import { ICustomer } from '@/types/models';

@Component({ components: { BankAccountForm, FinancialDataForm } })
export default class PersonalBankDataTab extends Vue {
  @Prop({ required: true }) private user!: ICustomer;

  @Emit()
  public validateField() {}
}
</script>
<style lang="less">
.mb {
  margin-bottom: @size-spacing-x500;
}
</style>
